export const FILE_FORMATS = ['png', 'jpg', 'jpeg', 'webp', 'gif'];
